export default __webpack_public_path__ + "static/media/gasTankSingle.7ee4b212.jpg";